import React from 'react';
import { IoArrowRedoOutline } from 'react-icons/io5';
import { XIcon } from '@heroicons/react/solid';
import { FaLock } from 'react-icons/fa';
import { useRouter } from 'next/router';

import { LOGIN_PAGE, SIGNUP_PAGE } from 'constants/pages';

import Link from 'components/Link';
import Modal from 'components/Modal/HeadlessUiModal';

export const AccessModal: React.FC<any> = ({ handleClose, isOpen, title }) => {
  const router = useRouter();

  const currentPath = router.asPath;

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="relative rounded-lg bg-palette-black-1 p-3">
        <button onClick={() => handleClose()} className="absolute right-3 top-2">
          <XIcon className="w-5" />
        </button>
        <div>
          <div className="relative max-h-24 overflow-hidden">
            <div className="absolute bottom-0 left-0 h-40 w-full bg-gradient-to-b from-palette-black-4/0 to-palette-black-4">
              &nbsp;
            </div>
          </div>
          <div className="space-y-4 py-8 text-center text-gray-400">
            <FaLock className="inline-block size-8 align-middle" />
            <div className="text-2xl font-medium">{title}</div>
            <div className="text-pretty font-normal text-brand-green-primary">
              Create a free account or &nbsp;
              <Link href={`${LOGIN_PAGE}?next=${currentPath}`} className="underline">
                login
              </Link>
              &nbsp;to view.
            </div>
            <div className="flex justify-center pt-5">
              <Link
                role="button"
                href={`${SIGNUP_PAGE}?next=${currentPath}`}
                className="flex items-center justify-center rounded-md  border border-transparent bg-brand-primary px-8 py-2 text-base font-medium text-white no-underline"
              >
                <span className="mr-2">Get Free Access</span>
                <IoArrowRedoOutline />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
